import React from 'react';

import { Select } from '@aline/common';
import { ConfirmationDialog, ConfirmationDialogVariant } from 'src/components';

interface SanityCheckMissingActionsBodyProps {
  onClickFixIssue: (e: React.MouseEvent) => void;
  onClose: () => void;
  open: boolean;
  workflowId: UUID;
}

export function MissingActionsDialog({
  onClickFixIssue,
  onClose,
  open,
}: SanityCheckMissingActionsBodyProps) {
  return (
    <ConfirmationDialog
      data-cy={Select.document.s4s.bottomBar.sanityCheck.missingActions.container}
      message="You have fields that are not assigned to recipients in your documents. Please assign all fields to a recipient to continue."
      open={open}
      primaryDataCy={Select.document.s4s.bottomBar.sanityCheck.missingActions.nextButton}
      primaryText="Fix Issue"
      secondaryDataCy={Select.document.s4s.bottomBar.sanityCheck.missingActions.cancelButton}
      title="Missing recipients detected"
      variant={ConfirmationDialogVariant.Error}
      onClickPrimary={onClickFixIssue}
      onClose={onClose}
    />
  );
}
